import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { RichTextEditorComponent } from './rich-text-editor.component';

export const MODULE_IMPORTS = [CommonModule, MatProgressSpinnerModule];

export const MODULE_DECLARATIONS = [RichTextEditorComponent];

@NgModule({
  declarations: MODULE_DECLARATIONS,
  imports: MODULE_IMPORTS,
  exports: [RichTextEditorComponent],
})
export class GalaxyRichTextEditorModule {}
